/**
 * RenderColorPicker
 */
import React from 'react';
import { Form, Label } from 'semantic-ui-react';

// Components
import AsyncCompactPicker from '../../components/AsyncCompactPicker';
import './styles.scss';

// Types

type Props = {
    input: {
        value: any;
        onChange: Function;
    };
    label: string;
    meta: {
        touched?: boolean;
        error?: string;
    };
    placeholder: string;
    disabled?: boolean;
    name: string;
};

export default class RenderColorPicker extends React.PureComponent<Props> {
    handleChange = (color: any): void => {
        const {
            input: { onChange }
        } = this.props;

        onChange(color.hex);
    };

    render(): React.ReactElement {
        const {
            input: { value },
            label,
            meta: { touched, error },
            disabled,
            name
        } = this.props;

        return (
            <Form.Field error={!!(touched && error)}>
                <label htmlFor={name}>{label}</label>
                <AsyncCompactPicker
                    name={name}
                    color={value}
                    onChange={this.handleChange}
                    colors={[
                        '#E57483', // Mid Red
                        '#FBD1A5', // Light Orange
                        '#FFE082', // Light Yellow
                        '#B9E1C9', // Light Green
                        '#BAD2CC', // Mid Green
                        '#98C1D9', // Mid Blue
                        '#BADDF5', // Light blue
                        '#E4BCD2', // Light Purple
                        '#E396DF', // Plum (Web)
                        '#D1C4E9', // Violet
                        '#D7D9D7', // Light Gray
                        '#DDDBCB' // Dust Storm
                    ]}
                    disabled={disabled}
                />
                {!!(touched && error) && (
                    <Label basic color="red" pointing>
                        {error}
                    </Label>
                )}
            </Form.Field>
        );
    }
}
